import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Key, CircleNotch } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

// Reveals + copies all saved API credentials for a provider account.
export const CopyApiButton = ({ provider, accountId, className = '' }) => {
  const [busy, setBusy] = useState(false);
  const copyText = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) { /* fall through to legacy */ }
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus(); ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  };
  const run = async () => {
    setBusy(true);
    let creds;
    try {
      const r = await axios.get(`${API}/api/reveal-credentials/${provider}/${accountId}`, { withCredentials: true });
      creds = r.data.credentials || {};
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not reveal credentials');
      setBusy(false);
      return;
    }
    const keys = Object.keys(creds);
    if (!keys.length) { toast.error('No saved credentials found'); setBusy(false); return; }
    const text = keys.length === 1 ? creds[keys[0]] : keys.map(k => `${k}: ${creds[k]}`).join('\n');
    const ok = await copyText(text);
    if (ok) toast.success(`Copied API credentials (${keys.join(', ')})`);
    else toast.error('Revealed, but clipboard is blocked by the browser');
    setBusy(false);
  };
  return (
    <button onClick={run} disabled={busy} data-testid={`copy-api-${accountId}`}
      title="Reveal & copy saved API credentials"
      className={`text-slate-400 hover:text-[#39FF14] transition-colors p-1 ${className}`}>
      {busy ? <CircleNotch size={20} className="animate-spin" /> : <Key size={20} />}
    </button>
  );
};
export default CopyApiButton;
